import { render, staticRenderFns } from "./Neuro.vue?vue&type=template&id=14c48966&scoped=true&"
import script from "./Neuro.vue?vue&type=script&lang=js&"
export * from "./Neuro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c48966",
  null
  
)

export default component.exports